// How far ahead an introducer may hold the valuation call. The title check is paid
// for the moment it runs, so an open-ended embargo means buying a Land Registry
// search for a family nobody has committed to approaching. Shared so the form, the
// server validation and the release job cannot drift apart.
export const MAX_DO_NOT_CONTACT_DAYS = 90;

import * as Enviroment from "./models/Enviroment";

export const sailHomesBrandConstants = (env: Enviroment.T) => ({
    homeURL: `https://${Enviroment.getDomainNameFromEnv(env)}/`,
    contact: {
        emailURL: "mailto:hello@sailhomes.co.uk?subject=Sail%20Homes%20Listing%20Enquiry",
        phoneURL: "tel:+448081965200",
        phoneText: "0808 196 5200",
    },
    faqURL: `https://${Enviroment.getDomainNameFromEnv(env)}/faq`,
    pricingURL: `https://${Enviroment.getDomainNameFromEnv(env)}/pricing`,
    forSale: `https://www.${Enviroment.getDomainNameFromEnv(env)}/listings`,
    privacyURL: `https://${Enviroment.getDomainNameFromEnv(env)}/privacy-policy`,
    valuationURL: `https://${Enviroment.getDomainNameFromEnv(env)}/valuation/your-details`,
    logoutUrl: `https://auth.${Enviroment.getDomainNameFromEnv(env)}/web/logout`,
    tncsUrl: `https://${Enviroment.getDomainNameFromEnv(env)}/terms-conditions`,
    complaintsUrl: `https://${Enviroment.getDomainNameFromEnv(env)}/pages/complaints-procedure`,
}) as const;

const sailLegalDomainName = (typeof process !== "undefined" && process.env && process.env.SAIL_LEGAL_DOMAIN_NAME) || "saillegal.local";
const sailHomesDomainName = (typeof process !== "undefined" && process.env && process.env.DOMAIN_NAME) || "sailhomes.local";

export const sailLegalBrandConstants = () => ({
    legalCSNumber: "0808 196 7007",
    logoUrl: `https://portal.${sailLegalDomainName}/static/img/sail_legal_logo.png`,
    colors: {
        navy: "#2D3D64",
        darkNavy: "#0E1E47",
        teal: "#35B8BE",
        midGrey: "#546285",
        lightGrey: "#9B9EB8",
        cardBorder: "#E4E5ED",
        cardBg: "#F8FCFD",
        emphasisBg: "#E0F5F8",
        white: "#FFFFFF",
        coral: "#FF8946",
    },
});

// Not SAIL_HOMES_ESTATE_AGENT.address: that is the trading address on the memorandum
// of sale. The two strings coincide today but are different facts.
export const PROPERTYBID_REGISTERED_OFFICE = "Shiplate Farm Retreat, Shiplate Road, Bleadon, Weston-super-Mare, BS24 0NY" as const;

// The viewing emails invite a reply ("just reply to this email"), so they must come from a
// mailbox a human reads. This one is connected to Front; `donotreply@` silently binned every
// reply a buyer sent at the point of highest intent.
export const SAIL_HOMES_VIEWINGS_EMAIL = `viewings@${sailHomesDomainName}`;

export const SAIL_HOMES_ESTATE_AGENT = {
    organisationName: "Sail Homes",
    contactName: "Keri Hutton",
    phoneNumber: "+448081965200",
    phoneNumberDisplay: "0808 196 5200",
    emailAddress: "hello@sailhomes.co.uk",
    address: "Shiplate Farm Retreat Shiplate Road, Bleadon, Weston-Super-Mare, England, BS24 0NY",
} as const;

// The floor on the Sail Homes agency fee, applying from 2026-11-01. A listing may override it
// via retool.listing.minimum_fee_pence; this is the value used when that is NULL.
export const SAIL_HOMES_MINIMUM_FEE_PENCE = 275000;

export type TCookiePreference = "all" | "none";
export const cookiePreferenceCookieName = "sailLegalClientCookiePreference";

// VAT CONSTANTS
// 20% - Current as of 2021-11-22
export const currentStandardVatRate = 0.20;
export const multipleToIncludeVAT = 1.2;

export const SES_MAX_RAW_MESSAGE_BYTES = 10 * 1024 * 1024;
const EMAIL_BODY_AND_HEADERS_RESERVE_BYTES = 1024 * 1024;
const BASE64_EXPANSION_MULTIPLIER = 1.37;
export const EMAIL_ATTACHMENTS_MAX_TOTAL_BYTES = Math.floor(
    (SES_MAX_RAW_MESSAGE_BYTES - EMAIL_BODY_AND_HEADERS_RESERVE_BYTES) / BASE64_EXPANSION_MULTIPLIER
);
